"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var AXSBlock_1 = __importDefault(require("../AXSBlock/AXSBlock"));
var Div = styled_components_1.default(AXSBlock_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-self: ", ";\n  align-items: ", ";\n  display: ", ";\n  flex-basis: ", "; // is auto correct default?\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  order: ", ";\n  min-width: auto;\n"], ["\n  align-self: ", ";\n  align-items: ", ";\n  display: ", ";\n  flex-basis: ", "; // is auto correct default?\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  order: ", ";\n  min-width: auto;\n"])), function (_a) {
    var alignSelf = _a.alignSelf;
    return (alignSelf ? alignSelf : 'auto');
}, function (_a) {
    var alignItems = _a.alignItems;
    return (alignItems ? alignItems : 'auto');
}, function (_a) {
    var flex = _a.flex;
    return (flex ? 'flex' : 'block');
}, function (_a) {
    var flexBasis = _a.flexBasis;
    return (flexBasis ? flexBasis : 'auto');
}, function (_a) {
    var flexGrow = _a.flexGrow;
    return (flexGrow ? flexGrow : 0);
}, function (_a) {
    var flexShrink = _a.flexShrink;
    return (flexShrink ? flexShrink : 1);
}, function (_a) {
    var order = _a.order;
    return (order ? order : 0);
});
var AXSFlexItem = function (props) {
    return (React.createElement(Div, __assign({}, props, { backgroundColor: props.backgroundColor, className: classnames_1.default(['c-axs-flex-item', props.className]) })));
};
AXSFlexItem.defaultProps = {
    alignSelf: 'auto',
    flexGrow: 0,
    flexShrink: 1,
    order: 0,
};
exports.default = AXSFlexItem;
var templateObject_1;
//# sourceMappingURL=index.js.map